module.exports = __webpack_public_path__ + "static/media/antic-home-tiny.23a88652.jpg";